module.exports = {"450204001":"河西街道","450204002":"南站街道","450204003":"鹅山街道","450204004":"柳南街道","450204005":"柳石街道","450204006":"银山街道","450204007":"潭西街道","450204008":"南环街道","450204100":"太阳村镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450204.json
// module id = 1909
// module chunks = 0